{
  "de": {
    "curriculum": {
      "confirmDelete": {
        "confirm": "Ja, löschen",
        "text": "Möchtest du „{filename}“ wirklich löschen? Die Datei und die durchsuchbaren Lehrplan-Inhalte werden entfernt.",
        "title": "Lehrplan löschen?"
      },
      "configure": "Lehrplan-Einstellungen öffnen",
      "contextPanel": {
        "loadFailed": "Die Lehrpläne konnten gerade nicht geladen werden. Versuche es später noch einmal.",
        "manage": "Eigene Lehrpläne verwalten",
        "matching": "Diese Lehrpläne passen zu den schulischen Eckdaten oben.",
        "noSubject": "Wähle oben ein Fach, dann zeigen wir dir passende Lehrpläne.",
        "noSubjectMatch": "Für das gewählte Fach führen wir keine Lehrpläne. Lade deinen eigenen hoch, dann nutzt die KI ihn.",
        "none": "Für diese Eckdaten haben wir noch keinen Lehrplan. Lade deinen eigenen hoch, dann nutzt die KI ihn.",
        "notFound": "Für die Eckdaten oben haben wir in {place} keinen passenden Lehrplan gefunden. Lade deinen eigenen hoch, dann nutzt die KI ihn.",
        "ownDocument": "eigenes Dokument",
        "title": "Lehrpläne",
        "unknownRegion": "Wir kennen dein Bundesland nicht. Damit die KI keinen falschen Lehrplan nutzt, verwendet sie dann keinen. Hinterlege dein Bundesland im Profil.",
        "used": "Auf diesen Lehrplänen basiert dieses Material.",
        "usedIn": "Auf diesen Lehrplänen für {place} basiert dieses Material."
      },
      "coverage": {
        "grades": "Klasse {range}",
        "heading": "Deine Fächer in {place}",
        "headingWithoutPlace": "Deine Fächer",
        "openProfile": "Profil öffnen",
        "profileIncomplete": "Hinterlege deine Fächer, Schulart und Klassenstufen im Profil, dann zeigen wir dir hier die passenden Lehrpläne.",
        "unmapped": "Für {labels} gibt es keinen eigenen Lehrplan. Lade deinen eigenen hoch, dann nutzt die KI ihn.",
        "editProfile": "Profil bearbeiten",
        "own": "Eigener",
        "none": "Kein Lehrplan für {place}",
        "noneOtherRegions": "Kein Lehrplan für {place}, nur für andere Bundesländer",
        "uploadHint": "Lade unten deinen eigenen hoch.",
        "more": "und {count} weitere"
      },
      "delete": "Lehrplan löschen",
      "deleted": "Lehrplan wurde gelöscht.",
      "deleteFailed": "Lehrplan konnte nicht gelöscht werden.",
      "empty": "Noch keine eigenen Lehrplandokumente hochgeladen.",
      "fields": {
        "country": "Land",
        "gradeLevel": "Klassenstufe",
        "region": "Region",
        "schoolType": "Schulart",
        "subject": "Fach",
        "title": "Titel"
      },
      "intro": "Wir nutzen die offiziellen Lehrpläne aus Deutschland, Österreich und der Schweiz. Zusätzlich kannst du eigene Lehrplandokumente hochladen, zum Beispiel ein schulinternes Curriculum. Wenn es für ein Fach einen eigenen Lehrplan gibt, richtet sich die KI zuerst danach.",
      "loading": "Lehrpläne werden geladen...",
      "notSet": "Nicht gesetzt",
      "placeholders": {
        "selectOrAddOptions": "Suchen, auswählen oder eigenen Wert eingeben"
      },
      "saved": "Lehrplan-Metadaten gespeichert.",
      "title": "Lehrpläne",
      "upload": "Lehrplan hochladen",
      "uploaded": "Lehrplan wurde hochgeladen und wird verarbeitet.",
      "uploadFailed": "Lehrplan konnte nicht hochgeladen werden.",
      "library": {
        "title": "Lehrpläne",
        "subtitle": "Was sieht der Lehrplan für deinen Unterricht vor? Wähle Land, Schulart, Fach und Jahrgangsstufe oder suche direkt nach einem Thema.",
        "search": {
          "label": "In Lehrplänen suchen",
          "placeholder": "Thema, Begriff oder Kompetenz suchen…",
          "submit": "Suchen",
          "clear": "Suche beenden",
          "resultsTitle": "{count} Treffer für „{query}“ | {count} Treffer für „{query}“",
          "noResultsTitle": "Keine Treffer für „{query}“",
          "noResultsText": "Versuche einen anderen Begriff oder entferne Fach- und Jahrgangsfilter.",
          "loadFailed": "Die Suche hat gerade nicht geklappt. Bitte versuche es noch einmal.",
          "examplesLabel": "Zum Beispiel:",
          "examples": "Evolution, Ökosystem, Quadratische Funktionen, Teilchenmodell, Hormone"
        },
        "filters": {
          "country": "Land",
          "region": "Bundesland",
          "regionCh": "Kanton",
          "allRegions": "Alle Regionen",
          "schoolType": "Schulart",
          "allSchoolTypes": "Alle Schularten",
          "subject": "Fach",
          "allSubjects": "Alle Fächer",
          "yourSubjects": "Deine Fächer",
          "otherSubjects": "Weitere Fächer",
          "subjectSearch": "Fach suchen…",
          "noDocuments": "noch keine",
          "editProfile": "Profil bearbeiten",
          "fromProfileFrame": "Vorausgewählt aus deinem Profil: {frame}."
        },
        "grades": {
          "title": "Jahrgangsstufe",
          "hint": "Die Balken zeigen, wie viele Lehrpläne es pro Stufe gibt.",
          "selected": "Nur Jahrgangsstufe {grade}",
          "showAll": "Alle zeigen",
          "gradeLabel": "Jahrgangsstufe {grade}, {count} Lehrplan | Jahrgangsstufe {grade}, {count} Lehrpläne",
          "primary": "Grundschule 1–4",
          "secondaryOne": "Sekundarstufe I 5–10",
          "secondaryTwo": "Sek. II 11–13",
          "short": "Jgst."
        },
        "list": {
          "count": "{count} Lehrplan | {count} Lehrpläne",
          "read": "Lesen",
          "loadFailed": "Die Lehrpläne konnten nicht geladen werden. Bitte versuche es noch einmal."
        },
        "empty": {
          "regionTitle": "Für {place} haben wir noch keine Lehrpläne",
          "regionText": "Wir nehmen nach und nach alle Länder auf. Den Lehrplan deiner Schule kannst du schon jetzt im KI-Chat hochladen und dort nutzen.",
          "filterTitle": "Keine Lehrpläne für diese Auswahl",
          "filterText": "Entferne einen Filter oder wähle eine andere Jahrgangsstufe.",
          "unknownFilter": "Diese Auswahl kennen wir nicht. Bitte wähle sie neu."
        },
        "reader": {
          "back": "Lehrpläne",
          "original": "Original öffnen",
          "contents": "Inhalt",
          "find": "In diesem Lehrplan suchen…",
          "findLabel": "In diesem Lehrplan suchen",
          "matches": "{count} Abschnitt | {count} Abschnitte",
          "otherGrades": "In anderen Jahrgangsstufen:",
          "hours": "ca. {hours} Std.",
          "verbatim": "Wortlaut aus dem amtlichen Lehrplan",
          "lostTable": "Hier steht im Original eine Tabelle, deren Inhalt sich nicht übernehmen ließ. Bitte im Original nachlesen.",
          "notFound": "Diesen Lehrplan gibt es nicht oder nicht mehr.",
          "chapterTruncated": "Dieses Kapitel ist sehr lang und hier gekürzt. Den vollständigen Text findest du im Original.",
          "textFailed": "Der Text dieses Lehrplans konnte nicht geladen werden. Lade die Seite neu, um es noch einmal zu versuchen.",
          "chapterFailed": "Dieses Kapitel konnte nicht geladen werden.",
          "retry": "Erneut versuchen"
        }
      },
      "ownDocumentsHeading": "Deine eigenen Lehrpläne",
      "processing": "Wird verarbeitet … die Kategorien erscheinen gleich hier.",
      "ready": "Bereit",
      "failed": "Konnte nicht verarbeitet werden.",
      "retry": "Erneut versuchen",
      "retryFailed": "Die Verarbeitung konnte nicht neu gestartet werden."
    }
  }
}
